import React, { Component } from 'react';
import { connect } from 'react-redux';
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Media from "./Media";
import Grid from "./Grid";
import Result from "./Result";
import * as ResponseData from './Saga/ResponseData';


interface Props {
    get_media_list: any,
    media_list: any,
    respose_list: any
}




interface State {

}

class CustomerList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);
        // props.get_media_list();
    }







    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12">
                    <Card >
                        <CardContent >
                            <Media list={this.props.media_list} />
                        </CardContent >
                    </Card >
                </div>

                <div className="item-outer col-lg-12">
                    <Card >
                        <CardContent >
                            {this.props.respose_list ? <Result /> : ""}
                        </CardContent >
                    </Card >
                </div>

                <div className="item-outer col-lg-12">
                    <Card >
                        <CardContent >
                            {this.props.respose_list ? <Grid /> : ""}
                        </CardContent >
                    </Card >
                </div>


            </div>
        );
    }
};


const mapStateToProps = (state: any) => {
    return {

        media_list: state.ResponseData.media_list,
        respose_list: state.ResponseData.respose_list,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_media_list(state: any) {
            dispatch(ResponseData.get_media_list(state))
        },


    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




